import { Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { LoggerService } from './shared/services/logger.service';
import { PrimeNG } from 'primeng/config';
import { it } from 'primelocale/js/it.js';
import { es } from 'primelocale/js/es.js';
import {SocketService} from "./shared/services/socket.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  protected socketService = inject(SocketService);
  protected logger = inject(LoggerService);
  private config = inject(PrimeNG);
  private locale = inject(LOCALE_ID);

  // private subscription: Subscription;
  messages: string[] = [];

  ngOnInit() {
    // Set PrimeNG translations based on current locale
    this.setPrimeNGTranslations();
  }

  private setPrimeNGTranslations() {
    // You'll need to import the appropriate PrimeNG translation
    // based on your locale
    switch (this.locale) {
      case 'en':
      case 'en-US':
        // English is default, no additional setup needed
        this.logger.debug('App translation changed for EN');
        break;
      case 'es':
      case 'es-ES':
        this.config.setTranslation(es);
        this.logger.debug('App translation changed for ES');
        break;
      case 'it':
      case 'it-IT':
        this.config.setTranslation(it);
        this.logger.debug('App translation changed for IT');
        break;
      // Add more locales as needed
      default:
        // Fallback to English
        break;
    }
  }

}
